import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../MovieCell.style';
import PropTypes from 'prop-types';
import { Button, Chip, IconButton, Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router';
import { ArrowBackIos } from '@material-ui/icons';
import CmtAvatar from '@coremat/CmtAvatar';
import StepperConvert from './StepperConvert';
import clsx from 'clsx';
import InfoIcon from '@material-ui/icons/Info';
const MovieCell = ({ movie }) => {
  const classes = useStyles();
  const history = useHistory();

  const { name, id, download_items, poster, uploaded } = movie;

  const handleConvert = () => {
    history.push(`/convert/?movie=${id}`);
  };

  const handleDetails = () => {
    history.push(`/convert-details/?movie=${id}`);
  };

  const emptyProgress = download_items.reduce(
    (accumulator, currentValue) => accumulator + currentValue.deactive_tapture_converts.length,
    0,
  );

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Box display="flex" alignItems="center">
            <Box mr={{ xs: 4, md: 5 }}>
              <CmtAvatar src={poster?.large} size={60} style={{ borderRadius: '6px' }} alt={name} />
            </Box>
            <Box>
              <Typography className={classes.titleRoot} component="div" variant="h4">
                {name}
              </Typography>
            </Box>
          </Box>
        </Box>
      </TableCell>
      <TableCell className={clsx(classes.tableCellRoot, classes.statusWrapper)} style={{ textAlign: 'end' }}>
        {uploaded && emptyProgress === 0 && (
          <Chip label={'غیر تپچری'} size="small" color={'primary'} style={{ alignSelf: 'center' }} />
        )}
        <Tooltip title="جزئیات">
          <IconButton onClick={handleDetails} aria-label="جزئیات">
            <InfoIcon />
          </IconButton>
        </Tooltip>
        <StepperConvert items={download_items} uploaded={uploaded} />
        <Button onClick={handleConvert}>
          آپلود <ArrowBackIos />
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default MovieCell;

MovieCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
